import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Password field with an eye button to show/hide what's typed. Hidden by default.
// Takes the same props as <input> (minus `type`); `children` render inside the wrapper
// before the input, for a left-side icon.
export default function PasswordInput({ className = '', children, ...props }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      {children}
      <input {...props} type={visible ? 'text' : 'password'} className={`${className} pr-10`} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-zinc-400 hover:text-ink"
        aria-label={visible ? 'Hide password' : 'Show password'}
        title={visible ? 'Hide password' : 'Show password'}
      >
        {/* Icon shows the current state: struck-through while hidden, open eye while shown. */}
        {visible ? <Eye size={16} /> : <EyeOff size={16} />}
      </button>
    </div>
  );
}
